import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PaysheetPage from './PaysheetPage';
import ManagePaymentsPage from './ManagePaymentsPage';
import SubscriptionPlanPage from './SubscriptionPlanPage';
import InvoicesPage from './InvoicesPage';

const TAB_COMPONENTS = [
  PaysheetPage,
  ManagePaymentsPage,
  SubscriptionPlanPage,
  InvoicesPage,
];

export default function BillingPage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState(0);
  const ActiveComponent = TAB_COMPONENTS[tab] || PaysheetPage;
  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label={t('billing.tabs.paysheet', 'Paysheet')} />
        <Tab label={t('billing.tabs.managePayments', 'Manage Payments')} />
        <Tab label={t('billing.tabs.subscriptionPlans', 'Subscription Plans')} />
        <Tab label={t('billing.tabs.invoices', 'Invoices')} />
      </Tabs>

      <ActiveComponent />
    </Box>
  );
}
